module.exports = __webpack_public_path__ + "img/banner-princiapal.1cd66066.png";